<page-header
        icon="{{['SEO', 'CHECKPOINTS'] | monIcons}}"
    header="{{'Issues by Type' | translate}}">
        <page-header-content>
            <div class="row">
                <div class="col-48 text-right">
                    <csv-export-button 
                            category="seo_checkpoints"
                            categoryName="{{ 'Issues by Type' | translate }}"
                            cls-size="py-2 px-3"
                            cls-margin="mr-0">
                    </csv-export-button>
                </div>
            </div>
        </page-header-content>
</page-header>

<!-- SEO Issues Sections -->
<div *ngFor="let category of issueCategories" class="mb-4">
    <pages-seo-issues
            [header]="category.header"
            [classification]="category.classification"
            [pageCount]="pageCount"
            [subHeader]="category.subHeader"
            [faIcon]="category.faIcon"
            [theme]="category.theme"
            [category]="category.category">
    </pages-seo-issues>
</div>
